/* ============================================================
   FUJINOMIDORI — TOP page shared script
   Loaded from layout/theme.liquid on the home page only.
   Section-specific behaviour lives inside each section file.
   ============================================================ */

/* --- Language switch (called from inline onclick in nav / hero) --- */
window.setLang = function setLang(ev, lang) {
  document.body.classList.toggle('lang-ja', lang === 'ja');
  document.body.classList.toggle('ja-mode', lang === 'ja');
  document.documentElement.lang = lang === 'ja' ? 'ja' : 'en';
  // Sync every language toggle button on the page (nav + hero)
  document.querySelectorAll('.lang-toggle button, .hero-lang-toggle button').forEach(function (b) {
    b.classList.remove('active');
    var isEn = b.textContent.trim() === 'EN';
    if ((lang === 'en' && isEn) || (lang === 'ja' && !isEn)) {
      b.classList.add('active');
    }
  });
};

/* --- Scroll reveal (shared by every section that uses .reveal) --- */
(function () {
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  function observeAll(scope) {
    (scope || document).querySelectorAll('.reveal:not(.visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }

  // Theme editor: re-observe when a section is added or re-rendered
  document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });
})();
